export default __webpack_public_path__ + "static/media/serviceBg1.8e02edf0.jpg";